module.exports = __webpack_public_path__ + "media/images/favicon-96x96-37fc29c2226af897353fbfaf132c91fe.png";